import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useParams } from 'react-router-dom'

import style from '../../style/crudLayout.scss'

type LinkProps = {
  link: string
  linkText: string
}

const PageLink = ({ linkText, link }: LinkProps) => {
  const locationPath = useLocation().pathname

  const activeCheck = link === locationPath ? style.activeLink : null

  return (
    <Link to={link} className={`${style.navLink} ${activeCheck}`}>
      {linkText}
    </Link>
  )
}

const SurveyNavigation = () => {
  const { surveyId } = useParams<{ surveyId: string }>()
  const { t } = useTranslation()
  return (
    <nav className={style.surveyDetailsNav}>
      <PageLink link={'/customers/surveys'} linkText={t('Back')} />
      <PageLink
        link={`/customers/surveys/${surveyId}/edit`}
        linkText={t('Edit')}
      />
      <PageLink
        link={`/customers/surveys/${surveyId}/preview`}
        linkText={t('Preview')}
      />
      <PageLink
        link={`/customers/surveys/${surveyId}/stats`}
        linkText={t('Stats')}
      />
    </nav>
  )
}

export const Layout = ({ children }: PropsWithChildren) => {
  return (
    <div className={'page-layout'}>
      <SurveyNavigation />
      {children}
    </div>
  )
}
